import { combineReducers } from 'redux'
import app from './app/reducer'

export default combineReducers({
  app,
})
